import { Reducer } from "redux";
import {
	DocumentApprovalRuleActions,
	DocumentApprovalRuleActionTypes
} from "../../Actions/DocumentApproval";
import { SalesActivityAutomationMetadataFilter } from "@/Contracts/Others/SalesActivity";
import { DocumentApproval } from "@/Contracts/DocumentApprovals";
export interface DocumentApprovalState {
	readonly isLoading: boolean;
	readonly currentActiveDocumentApproval: DocumentApproval | null;
	readonly documentApprovalList: DocumentApproval[];
	readonly filterMetadata: SalesActivityAutomationMetadataFilter[];
	readonly editDocumentApproversDrawerOpen: boolean;
	readonly isApprovalRuleFinalModalOpen: boolean;
}

export const initialDocumentApprovalState: DocumentApprovalState = {
	isLoading: false,
	currentActiveDocumentApproval: null,
	documentApprovalList: [],
	filterMetadata: [],
	editDocumentApproversDrawerOpen: false,
	isApprovalRuleFinalModalOpen: false
};

export const DocumentApprovalReducer: Reducer<DocumentApprovalState, any> = (
	state: DocumentApprovalState = initialDocumentApprovalState,
	action: DocumentApprovalRuleActions
) => {
	switch (action.type) {
		case DocumentApprovalRuleActionTypes.SHOW_DOCUMENT_APPROVAL_RULE_LOADER: {
			return {
				...state,
				isLoading: true
			};
		}
		case DocumentApprovalRuleActionTypes.HIDE_DOCUMENT_APPROVAL_RULE_LOADER: {
			return {
				...state,
				isLoading: false
			};
		}
		case DocumentApprovalRuleActionTypes.SHOW_EDIT_DOCUMENT_APPROVERS_DRAWER: {
			return {
				...state,
				editDocumentApproversDrawerOpen: true
			};
		}
		case DocumentApprovalRuleActionTypes.HIDE_EDIT_DOCUMENT_APPROVERS_DRAWER: {
			return {
				...state,
				editDocumentApproversDrawerOpen: false
			};
		}
		case DocumentApprovalRuleActionTypes.FETCH_DOCUMENT_APPROVAL_RULE_FILTERS_METADATA_REQUESTED: {
			return state;
		}
		case DocumentApprovalRuleActionTypes.FETCH_DOCUMENT_APPROVAL_RULE_FILTERS_METADATA_SUCCESSFUL: {
			return {
				...state,
				filterMetadata: [...action.filters]
			};
		}
		case DocumentApprovalRuleActionTypes.FETCH_DOCUMENT_APPROVAL_RULE_FILTERS_METADATA_FAILED: {
			return state;
		}

		case DocumentApprovalRuleActionTypes.RESET_DOCUMENT_APPROVAL_RULE_FILTERS_METADATA: {
			return {
				...state,
				filterMetadata: []
			};
		}

		case DocumentApprovalRuleActionTypes.UPDATE_CURRENT_ACTIVE_DOCUMENT_APPROVAL_RULE: {
			return {
				...state,
				currentActiveDocumentApproval: action.documentApprovalRule
			};
		}

		case DocumentApprovalRuleActionTypes.RESET_CURRENT_ACTIVE_DOCUMENT_APPROVAL_RULE: {
			return {
				...state,
				currentActiveDocumentApproval: null
			};
		}

		case DocumentApprovalRuleActionTypes.FETCH_ALL_DOCUMENT_APPROVAL_RULES_REQUESTED: {
			return state;
		}
		case DocumentApprovalRuleActionTypes.FETCH_ALL_DOCUMENT_APPROVAL_RULES_SUCCESSFUL: {
			return {
				...state,
				documentApprovalList: [...action.documentApprovalRules]
			};
		}
		case DocumentApprovalRuleActionTypes.FETCH_ALL_DOCUMENT_APPROVAL_RULES_FAILED: {
			return state;
		}

		case DocumentApprovalRuleActionTypes.RESET_DOCUMENT_APPROVAL_RULES_LIST: {
			return {
				...state,
				documentApprovalList: []
			};
		}

		case DocumentApprovalRuleActionTypes.FETCH_DOCUMENT_APPROVAL_RULE_REQUESTED: {
			return state;
		}
		case DocumentApprovalRuleActionTypes.FETCH_DOCUMENT_APPROVAL_RULE_SUCCESSFUL: {
			return {
				...state,
				currentActiveDocumentApproval: action.documentApprovalRule
			};
		}
		case DocumentApprovalRuleActionTypes.FETCH_DOCUMENT_APPROVAL_RULE_FAILED: {
			return state;
		}

		case DocumentApprovalRuleActionTypes.CREATE_DOCUMENT_APPROVAL_RULE_REQUESTED: {
			return state;
		}
		case DocumentApprovalRuleActionTypes.CREATE_DOCUMENT_APPROVAL_RULE_SUCCESSFUL: {
			return state;
		}
		case DocumentApprovalRuleActionTypes.CREATE_DOCUMENT_APPROVAL_RULE_FAILED: {
			return state;
		}
		case DocumentApprovalRuleActionTypes.UPDATE_DOCUMENT_APPROVAL_RULE_REQUESTED: {
			return state;
		}
		case DocumentApprovalRuleActionTypes.UPDATE_DOCUMENT_APPROVAL_RULE_SUCCESSFUL: {
			return {
				...state,
				documentApprovalList: [
					...state.documentApprovalList.map(approval =>
						approval.id === action.documentApprovalRule.id
							? action.documentApprovalRule
							: approval
					)
				]
			};
		}
		case DocumentApprovalRuleActionTypes.UPDATE_DOCUMENT_APPROVAL_RULE_FAILED: {
			return state;
		}
		case DocumentApprovalRuleActionTypes.DELETE_DOCUMENT_APPROVAL_RULE_REQUESTED: {
			return state;
		}
		case DocumentApprovalRuleActionTypes.DELETE_DOCUMENT_APPROVAL_RULE_SUCCESSFUL: {
			return {
				...state,
				documentApprovalList: [
					...state.documentApprovalList.filter(
						rule => rule.id !== action.documentApprovalRuleId
					)
				]
			};
		}
		case DocumentApprovalRuleActionTypes.DELETE_DOCUMENT_APPROVAL_RULE_FAILED: {
			return state;
		}

		case DocumentApprovalRuleActionTypes.UPDATE_APPROVAL_FINAL_MODAL_VISIBILITY: {
			return {
				...state,
				isApprovalRuleFinalModalOpen: action.visible
			};
		}

		default:
			return state;
	}
};
